export default {
  path: '/price',
  title: '秒报价',
  icon: 'btc',
  children: [
    {
      path: 'proofing',
      title: '打样管理',
      icon: 'file-image-o',
      children: [
        {
          path: 'node',
          title: '打样节点',
          component: 'price/proofing/node'
        },
        {
          path: 'template',
          title: '节点模板',
          component: 'price/proofing/template'
        },
        {
          path: 'edition',
          title: '版单类型',
          component: 'price/proofing/edition'
        },
        {
          path: 'list',
          title: '打样列表',
          component: 'price/proofing/list'
        },
        {
          path: 'schedule',
          title: '打样进度',
          component: 'price/proofing/schedule'
        }
      ]
    }
  ]
}
